<template>  
    <div class="detected-personality-container" v-if="isPersonalitiesLoaded">
        <div v-for="faceObj in getDetectedFacesList" :key="faceObj.uuid"  class="face-and-name-wrapper">
            <div v-if="getPersonalityImage(faceObj) == null" :style="style(faceObj.name)" class="face-image-wrapper" :title="faceObj.name">{{faceObj.name.split("")[0]}}</div>
            <div class="face-image-wrapper" v-else>
                <img :src="getProxyConvertedURL(getPersonalityImage(faceObj))" style="width: 100%; height: 100%; border-radius: 6px; margin-bottom: 5px;"/>
            </div>
            <div class="personality-name" v-if="isSearchHighlightRequired">
                <span v-html="getHighlightName(faceObj.name)"></span>
            </div>
            <div class="personality-name" v-else>
                <template >{{faceObj.name}}</template>
            </div>
        </div>
    </div>
</template>

<script>
import Utils from '../../components.utils.js';
import {mapActions} from 'vuex';
export default {
    name:'detectPersonalitiesComp',
    props:{
        assetDetailsFromParent:{
            type: Object,
            default(){
                return {};
            }
        },
        faceDetectionList:{
            type: Array,
            default(){
                return [];
            }
        },
        imageWidth:{
            type : Number,
            default(){
                return null;
            }
        },
        isSearchHighlightRequired:{
           required: false,
           type : Boolean,
           default(){
                return false;
           },
        }
    },
    data(){
        return {
            assetDetails:{},
            defaultImageWidth: 120,
            personalitiesMap:{},
            isPersonalitiesLoaded: false,
        }
    },
    methods:{
       getPersonalityImage(faceObj){
         if(this.personalitiesMap[faceObj.object_id])
          return this.personalitiesMap[faceObj.object_id].profile_image;

         return null;
       },
       getThumbnailPath(file){
          return Utils.getThumbnailPathfromFileInfo(file)
       },
       getImageWith(){
           if(this.imageWidth){
                 return this.imageWidth;
           }
          return this.defaultImageWidth;
       },
       getHighlightName(name){
           return this.$parent.highlightTranscript(name);
       },
       style(name){
            let style = {
                'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
            }
            return style
       },
       ...mapActions('faceDetection',['getPersonalitiesListByServer']),
    },
    created(){
        this.assetDetails = this.assetDetailsFromParent;
        this.$nextTick(()=>{
            if(this.assetDetailsFromParent && this.assetDetailsFromParent.personality_info){
                this.assetDetailsFromParent.personality_info.forEach(el => {
                   this.personalitiesMap[el._id] = el;
                });
            }

            this.$nextTick(()=>{
                this.isPersonalitiesLoaded = true;
            });
        });
    },
    computed:{
        getDetectedFacesList(){
            return this.faceDetectionList.filter((e) => e.name);
        }
    },
    watch:{
       assetDetailsFromParent(newVal,oldVal){
        if(oldVal != newVal){
           this.assetDetails = newVal;
         }
       }
    }
}
</script>

<style scoped>
   .detected-personality-container{ 
        height:100%;
        width: 100%;
        display: flex;
        /* align-items: center; */
        gap: 6px;
        flex-direction: column;
   }
   .face-image-wrapper{
        height: 36px;
        width: 36px;
        min-width: 36px;
        border: 1px solid #4a4a4a;
        border-radius: 8px;
        text-align: center;
        line-height: 35px;
        text-transform: uppercase;
        margin-top: 3px;
        font-size: 18px;
   }
   .face-and-name-wrapper{
        display:flex;
        align-items: center;
        width:100%;
        height:100%;
        gap: 6px;
   }
</style>